export default __webpack_public_path__ + "static/bonvivant-ede71acf134fe0a2180e1c67a230da83.woff";